import { NextPage } from 'next'
import HomeScreen from '../screens/Home'
import AppHomeScreen from '../screens/App-Home'
import SMHomeDialog from '../containers/Home/Dialog'
import SMAppHomeDialog from '../containers/App-Home/Dialog'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { HomeADUrl } from '../common/url'
import { App_Language_key } from '../common/config'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const SMHome: NextPage = () => {

    const { showDesktopUI } = ScreenWidthPort()

    const [adData, setADData] = useState([])

    const [openAD, setOpenAD] = useState(false)

    const [openAppAD, setOpenAppAD] = useState(false)

    const onAction = () => {
        if (showDesktopUI) {
            setOpenAD(false)
        } else {
            setOpenAppAD(false)
        }
    }

    const onHandleCloseAD = () => {
        setOpenAD(false)
    }

    const onHandleCloseAppAD = () => {
        setOpenAppAD(false)
    }

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    useEffect(() => {
        let mounted = true
        const fetchData = async () => {
            try {
                const response = await axios.get(HomeADUrl + '?sort=sequence:ASC&publicationState=live&filters[language][$eq]=' + language)
                if (mounted) {
                    if (sessionStorage.getItem('ADDATA') !== JSON.stringify(response.data['data']) && response.data['data'] !== null && response.data['data'].length > 0) {
                        sessionStorage.setItem('ADDATA', JSON.stringify(response.data['data']))
                        if (response.data['data'] !== null && response.data['data'].length > 0) {
                            setADData([response.data['data'][0]])
                            if (showDesktopUI) {
                                setOpenAD(true)
                            } else {
                                setOpenAppAD(true)
                            }
                        }
                    }
                }
            } catch (error) {
                console.error(error)
            }
        }

        fetchData()

        return () => {
            mounted = false
        }
    })

    return (
        <>
            {showDesktopUI ? (<HomeScreen />) : (<AppHomeScreen />)}
            <SMHomeDialog open={openAD} onClose={onHandleCloseAD} onAction={onAction} adData={adData}></SMHomeDialog>
            <SMAppHomeDialog open={openAppAD} onClose={onHandleCloseAppAD} onAction={onAction} adData={adData}></SMAppHomeDialog>
        </>
    )
}
